import apiUrl from '../../../constants';
import  imageGet from '../../../constants';
import  bucketNames from '../../../constants';
import  constants  from '../../../constants';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import {getshippingidDetails, getBagShipmentSummery, weightVarianceData} from '../../../services/getSummeryData';
import {getHubCity} from '../../../services/fmsGethubList';
import {checkFileType} from '../../../services/utility';
import {getClientList} from '../../../services/B2b/services/getClientList';
import { fetchimageObject, extractObjectFromKey, fetchClientImages,getAssignBatchId,sortingImages,disputeLogs,getImage, getRTOProfarma, getInternalLogs,qcImagesFeching, qcImages, getImgVidProofs} from '../../../services/externalDispute';
import { canBypassShipmentSummaryAwbPrefixValidation } from '../../../common/shipmentSummaryAccess';

export default {
  name: 'summerPageComponent',
  components: {
    VueElementLoading,
  },
  data() {
    return {
      // pop-up data
      summeryData: {},
      bagShipmentSummery: {},
      token: '',
      isDataFound: true,
      hubList:[],
      clienList:[],
      hubcitydata:[],
      cityData:'',
      Isvideo: false,
      mediaURL: '',
      showModal: false,
      assetsByExecutive: [],
      podImages:'',
      flaggedImage0:'',
      flaggedImage1:'',
      srImagesArray: [],
      rtoProfarma:'',
      getSorterImages:[],
      disputeDataLog:[],
      actionNameList:[],
      imagesDataList:'',
      internalLogs: [],
      sorterImageBucket:"xb-xbsorterimages",
      WHHandoverOTPVerifiedFlag:'',
      podImage: [],
      weightVariance: [],
      qcImagesFeching:[],
      steps: [
        { label: 'Shipment' },
        { label: 'Manifest' },
        { label: 'Customer' },       
        { label: 'Pickup' },
        { label: 'Transit' },
        {label: 'Investigation'},
        { label: 'Images'},
        { label: 'Variance'},
        { label: 'Journey' }
      ],
      PickupProductImage: [],
      images: [],
      currentImageIndex: 0,
      modalHeader: 'Images',
      flaggedImages: [],
      awbnumber:'',
      Disabled:true,
      buttonDisable:true,
      titledisable: false,
      previewUrl: null,
      previewType: null,
      STDassets : [],
      showUrlOnly: false,
      proofUrl : null,
      copied : false,
      username: '',
      searchLoading: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.fullPath !== '/')window.localStorage.setItem('backURL',from.fullPath);
    })
  },
  mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.token = userToken.replace(/"/g, '');
    this.username = (window.localStorage.getItem('username') || '').toString().trim().toLowerCase();
    this.hubList = JSON.parse(window.localStorage.getItem("hubList"));
    this.actionNameList = JSON.parse(window.localStorage.getItem("actioncodeList"));
    this.listOfClientData();
    this.awbnumber = (this.$route.query.awb || '').toString().trim();
    if (this.awbnumber) {
      this.getSummeryData();
      return;
    }
    this.Disabled = false;
    this.buttonDisable = false;
    this.titledisable = true;
    
   // this.ImageView()
  },
  computed: {
    checkDisabled: function () {
      return !this.Disabled;
    },
  },
  
  methods: {

    number_format(num) {
      let obj2 = new Intl.NumberFormat('en-US');  
      return obj2.format(num);  
    },

    date_format(date) {
      return moment(date).format('D MMMM YYYY');
    },
    normalizeQCLabel(value) {
      return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
    },
    formatValueToCheck(value, type) {
      if (this.normalizeQCLabel(type) !== 'boolean') return value;
      const normalized = this.normalizeQCLabel(value);
      if (['y', 'yes', 'true'].includes(normalized)) return 'Yes';
      if (['n', 'no', 'false'].includes(normalized)) return 'No';
      return value;
    },
    getSRAnswer(label, index) {
      const qcConfigurables = this.summeryData
        && this.summeryData.QCParameters
        && Array.isArray(this.summeryData.QCParameters.qcConfigurables)
        ? this.summeryData.QCParameters.qcConfigurables
        : [];
      const normalizedLabel = this.normalizeQCLabel(label);
      const matchedQuestion = qcConfigurables.find(
        (item) => item && (
          this.normalizeQCLabel(item.Lable) === normalizedLabel
          || this.normalizeQCLabel(item.Descripton) === normalizedLabel
        )
      );
      if (matchedQuestion) return matchedQuestion.PostValue;
      return '-';
    },
    resetForm() {
      this.awbnumber = '';
      this.Disabled=false;
      this.titledisable=true
      this.STDassets = []

    },
    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        const offset = -140; // Adjust this value to scroll up by a certain amount
        const elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition + offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    },

    formatNumber(number) {
      return number < 10 ? `0${number}` : number;
    },

    async listOfClientData() {
      this.clienList = await getClientList(this.token);     
    },

    async getSummeryData(){
      try {
      const shippingid = (this.awbnumber || this.$route.query.awb || '').toString().trim();
      const routeAwb = (this.$route.query && this.$route.query.awb ? this.$route.query.awb : '').toString().trim();
      const routeAccessKey = (this.$route.query && this.$route.query.accessKey ? this.$route.query.accessKey : '').toString().trim();
      const isLinkNavigation = !!routeAwb && !!routeAccessKey && shippingid === routeAwb;
      const isBypassUser = canBypassShipmentSummaryAwbPrefixValidation(this.username || window.localStorage.getItem('username'));
      if (!shippingid) {
        this.Disabled = false;
        this.buttonDisable = false;
        this.titledisable = true;
        this.$alertify.error("The Shipping ID field is required.");
        return;
      }
      if (!isLinkNavigation && !isBypassUser && !/^2\d+$/.test(shippingid)) {
        this.Disabled = false;
        this.buttonDisable = false;
        this.titledisable = true;
        this.$alertify.error("This Shipping ID cannot be searched here.");
        return;
      }
      this.searchLoading = true;
      this.awbnumber = shippingid;
      let input = {
        "shippingid": shippingid
      }
      let {data} = await getshippingidDetails(input, this.token);
      if (data.ReturnCode == 103) {
        this.Disabled = false;
        this.buttonDisable = false;
        this.titledisable = true;
        this.$alertify.error("Shipping ID not found");
      }
      if(data.ReturnCode == 100){
        this.titledisable = false
        this.Disabled=true
        this.buttonDisable = true
        this.isDataFound = true;
        this.disputeDataLog = [];
        this.assetsByExecutive = [];
        this.irtUploadedAssets = [];
        this.weightVariance = [];
        this.STDassets = [];
        this.getSorterImages = [];
        this.PickupProductImage = [];
        this.flaggedImages = [];
        this.summeryData = data.result;
        let result = await getBagShipmentSummery(input,this.token);
        this.bagShipmentSummery = result.data.ShipmentDetails;
        let disputelog = await disputeLogs(input,this.token);
        this.disputeDataLog=disputelog.data
        this.bagShipmentSummery.Transactions.forEach(ele => this.disputeDataLog.push(ele))
        this.disputeDataLog.sort(function(obj1, obj2){
          var sysdate1 = obj1.CreatedDate, sysdate2 = obj2.CreatedDate
          return moment(new Date(sysdate2))-moment(new Date(sysdate1)) //sort by sysdate2 decending
         })
        let hubcitydata=[this.bagShipmentSummery.CurrentHubID,this.bagShipmentSummery.OriginHubID,this.bagShipmentSummery.FinalDestinationID]
        this.cityData = await getHubCity(this.token,hubcitydata);
        let getData = await getAssignBatchId(input,this.token);
        this.rtoProfarma = await this.getRTOProfarmaPDF(getData.data.data.DigitalProfarmaDetailsURL) || 'NA';
        this.WHHandoverOTPVerifiedFlag=getData.data.data.WHHandoverOTPVerifiedFlag
        let SorterImage = await sortingImages(input,this.token);
        let qcImagesFeching
        if(this.summeryData.BusinessFlow == "Reverse"){
          qcImagesFeching = await qcImages(input,this.token);
         if(qcImagesFeching.data.code == 200)   {
          this.qcImagesFeching = qcImagesFeching.data.data.map(({ ImageUrl }) => ImageUrl);
         }
        }
        if(SorterImage.data.ReturnCode == 100) {
          SorterImage.data.SorterImageDetails.forEach(({ ImageURL }) => {
            this.setImageView(ImageURL, this.sorterImageBucket)
                .then((result) => {
                    // Handle the result for this specific image
                    this.getSorterImages.push(result);
                })
          });
        }  

        if(this.summeryData.ProductDetails && this.summeryData.ProductDetails.PickupProductImage) {
          this.summeryData.ProductDetails.PickupProductImage.forEach(({ ImageURL }) => {
            this.setImageView(ImageURL, this.sorterImageBucket)
                .then((result) => {
                    // Handle the result for this specific image
                    this.PickupProductImage.push(result);
                })
          }); 
        }

        if(this.summeryData.ProductDetails && this.summeryData.ProductDetails.clientQC) {
          this.summeryData.ProductDetails.clientQC = this.summeryData.ProductDetails.clientQC.filter(element => element.Label !== null);
        } else if(this.summeryData.ProductDetails) {
          this.summeryData.ProductDetails.clientQC = []
        }

        
        // if(this.summeryData.ClientId && this.summeryData.ShipmentStatus=='WHHandover' && getData.data.code == 200)this.podImages = `AndroidApp/${this.summeryData.ClientId}_Delivery_sign_1.jpg`;
        // if(!this.summeryData.ClientId && this.summeryData.ShipmentStatus=='WHHandover' && getData.data.code == 200)this.podImages = `RTO//sign/${getData.data.data.AssignBatchNumber}.jpg`;
        this.podImages = `AndroidApp/${shippingid}_Delivery_sign_1.jpg`;
        this.setImageView(`RTO/rto_damaged/${shippingid}_0.jpg`)
        .then((result) => {
          this.flaggedImages.push(result)
        })

       this.setImageView(`RTO/rto_damaged/${shippingid}_1.jpg`)
        .then((result) => {
          this.flaggedImages.push(result)
        })
        this.srImages();
        this.getInvestigationMedia(shippingid);
        this.weightVarianceImages(shippingid);
        this.getWHHandoverProofs(shippingid);
        this.getInternalLogs(shippingid);
        this.getPODImage(shippingid,this.summeryData.ClientId);
        return;
      }
      this.isDataFound = false;

    } catch (error) {
      this.$alertify.error("Unable to fetch shipment summary right now.");
      console.log('getSummeryData error :: ', error);
    } finally {
      this.searchLoading = false;
    }
    },

    async getRTOProfarmaPDF(url){
      return new Promise((resolve, reject) => {
        let input = {
          url : url
        }
        getRTOProfarma(input, this.token).then(result => {
          let data = result.data;
          if(data.code == 200){
            return resolve(data.data);
          }
          return resolve(null);
        });
      });
    },

    async srImages(){
      let pickupdone = `ReversePickup/${this.summeryData.ClientId}/${this.summeryData.ShippingID}/PickupDone/`;
      let noPickup = `ReversePickup/${this.summeryData.ClientId}/${this.summeryData.ShippingID}/NoPickup/`;
      
      let imagesDone = await this.fetSRImages(pickupdone);
      if(imagesDone.statusCode !== 100){
        imagesDone = await this.fetSRImages(noPickup);
      }
      console.log(imagesDone);
      if (imagesDone.statusCode == 100) {
        imagesDone.data.Contents.forEach(keys => {
          
          let input = {
            bucketName: (process.env.NODE_ENV == 'production') ? constants.prodS3Bucket : constants.stageS3Bucket,
            key: keys.Key
          }
          getImage(input, this.token).then(res => {
            const finalImage = res.data.ImageData;
            // let buff = new Buffer.from(finalImage);
            // let base64data = buff.toString('base64');
            // let assetData = `data:video/mp4;base64,${base64data}`;
            // console.log(assetData,"assetData");
            this.srImagesArray.push({ url: finalImage, file: keys.Key});
          });
        });
      }
    },
    
    async fetSRImages(path,bucket){  
        let { data } = await fetchimageObject(path, this.token);
        return data;
    },

    async getInternalLogs(shippingId){
        this.internalLogs = [];
      let input = {
        shippingid: shippingId
      }
      getInternalLogs(input, this.token).then(res => {
        if(res.data.code == 200){
          res.data.data.forEach(obj => {
            this.internalLogs.push(obj);
          });
        }
      })
    },
    
    async ImageView(ImageView,sorterImageBucket) {
      let awsBucketName;
      if(sorterImageBucket){
        ImageView = ImageView.replace(/^"(.*)"$/, '$1');
        ImageView = ImageView.replace('xb-xbsorterimages/', '');
        awsBucketName = sorterImageBucket
      }
      else{
        awsBucketName = bucketNames.awsBucketName

      }
      let input = {
        bucketName: awsBucketName,
        key:ImageView
      };
      this.imagesDataList=''

        let imagesData = await getImage(input,this.token);
        this.imagesDataList=imagesData.data.ImageData
    },

    async getInvestigationMedia(awb){
      const shippingid = (awb || this.awbnumber || this.$route.query.awb || '').toString().trim();
      if (!shippingid) return;
      let key = `Investigation/${shippingid}/Image`;
      let { data } = await fetchimageObject(key, shippingid, this.token);
      if (data.statusCode == 100) {
        data.data.Contents.forEach(keys => {
          extractObjectFromKey(keys.Key, this.myStr).then(res => {
            const finalImage = res.data.ImageData.Body.data;
            let buff = new Buffer.from(finalImage);
            let base64data = buff.toString('base64');
            let mimeType = this.isVideo(keys.Key) ? 'video/mp4' : 'image/jpeg'
            let assetData = `data:${mimeType};base64,${base64data}`;
            // console.log(assetData,"assetData");
            this.assetsByExecutive.push({ url: assetData, file: keys.Key});
          });
        });
        if (data.data.videokeyUrl){
          this.assetsByExecutive.push({ url: data.data.videokeyUrl, file: data.data.videokey.Key});
        }
      }
    },

    back(){
      this.$router.push({ path: '/InvestigationShipmentsDetails' });
    },

    async weightVarianceImages(awb){
      const shippingid = (awb || this.awbnumber || this.$route.query.awb || '').toString().trim();
      if (!shippingid) return;
      let input = {
        shippingid: shippingid
    }

      weightVarianceData(input,this.token).then(res => {
        this.weightVariance = res.data.ReturnData ? res.data.ReturnData.SorterData : '';
      })
    },

    sorterImagesFix(url){
      let sorterURL = url.replace('xb-xbsorterimages/', '');
      this.showMediaOfImage(sorterURL,this.sorterImageBucket);
    },

    convertDate(date){
      return moment(date).format('YYYY-MM-DD HH:MM:SS');
    },

    async investigationShowMedia(url,file){
      this.imagesDataList=''
      this.Isvideo = false;
      this.showModal = true;
      let filename = file.substring(file.lastIndexOf('/') + 1);
      let fileExtension = filename.split('.').pop();
      let fileType = await checkFileType(fileExtension);
      if(fileType == 'Video') this.Isvideo = true;
      this.imagesDataList = url;
    },

    async showMedia(data, index, title){
      this.currentImageIndex = index;
      this.showModal = true;
      this.images = [];
      this.currentImageIndex = index;
      data.forEach(element => {
         if(element.ImageUrl != undefined) {
           this.images.push(element.ImageUrl)
         } else  if(element.url != undefined) {
          this.images.push(element.url)
        } else if(element.imageUrl != undefined) {
          this.setImageView(element.imageUrl, this.sorterImageBucket).then((result) => {
            this.images.push(result)
          })
        } else {
          this.images.push(element)
        }
      });
      this.modalHeader = title
    },

    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
      } else {
        this.currentImageIndex = this.images.length - 1; // Loop back to the last image
      }
    },

    nextImage() {
      if (this.currentImageIndex < this.images.length - 1) {
        this.currentImageIndex++;
      } else {
        this.currentImageIndex = 0; // Loop back to the first image
      }
    },

    async showMediaOfImage(url,sorterImageBucket){
      this.ImageView(url,sorterImageBucket)
      this.showModal = true;
      this.imagesDataList = url;
    },

    async getPODImage(shippingid,clientid){
      
      let bucket = constants.stageS3Bucket;
      let forwardPath = `AndroidApp/${shippingid}_Delivery_sign_1.jpg`;
      let reversePath = `Test/ReversePickup/${clientid}/sign/${shippingid}.jpg`;
      if(process.env.NODE_ENV == 'production'){
        bucket = constants.prodS3Bucket;
        reversePath = `ReversePickup/${clientid}/sign/${shippingid}.jpg`;
      }
      
      let podData = await this.getTheImages(bucket,reversePath);
      if(podData.statusCode !== 200){
        podData = await this.getTheImages(bucket,forwardPath);
      }
      this.podImage.push({ url: podData.ImageData, file: ''});

    },

    async getTheImages(bucket,path){
      return new Promise((resolve, reject) => {
        let input = {
          bucketName: bucket,
          key: path
        }
        getImage(input, this.token).then(data => {
          return resolve(data.data);
        });
      });
    },

    closeImage() {
      this.showModal = false;
    },
    
    async setImageView(ImageView,sorterImageBucket) {
      let awsBucketName;
      if(sorterImageBucket){
        ImageView = ImageView.replace(/^"(.*)"$/, '$1');
        ImageView = ImageView.replace('xb-xbsorterimages/', '');
        awsBucketName = sorterImageBucket
      }
      else{
        awsBucketName = bucketNames.awsBucketName

      }
      let input = {
        bucketName: awsBucketName,
        key:ImageView
      };
        this.imagesDataList=''

        let imagesData = await getImage(input,this.token);
        return imagesData.data.ImageData;
    },
    isVideo(url) {
      return /\.(mp4|webm|ogg)$/i.test(url);
    },
    isVideoFile(dataURI) {
      const mimeType = dataURI.split(",")[0].split(":")[1].split(";")[0];  
      return mimeType.startsWith("video/");
  },
  togglePlayPause(index) {
    const video = this.$refs.videoPlayers[index];

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  },
  async getWHHandoverProofs(awb) {
    const awb1 = (awb || this.awbnumber || this.$route.query.awb || '').toString().trim();
    if (!awb1) return;
      let input = {
        awb: awb1,
        status: 20
      }
      const response = await getImgVidProofs(input, this.token)
      if (response.data.statusCode !== 100) {
        return;
      }
      const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'webm'];

      let assets = response.data.data.reduce((acc, item) => {
        const key = item.key ? item.key.toLowerCase() : "";

        if (key.includes("video")) {
          acc.videourl.push({ UnboxingVideoProof1: item.url,broken : false });
        } else if (key.includes("image")) {
          acc.clientImages.push({ attachment: item.url,broken : false  });
        } else {
          acc.clientImages.push({ attachment: item.url,broken : false   });
        }

        return acc;
      }, { clientImages: [], videourl: [] });
      this.STDassets = assets;
    },
    openPreview(url, type) {
      this.previewUrl = url;
      this.previewType = type;
    },
    closePreview() {
      this.previewUrl = null;
      this.previewType = null;
    },
    openUrlModal(url, type) {
      this.proofUrl = url;
      this.previewType = type;
      this.showUrlOnly = true;
    },
    closeProofPreview() {
      this.proofUrl = null;
      this.previewType = null;
      this.showUrlOnly = false;
    },
    openInNewTab(url) {
      if (!url) return;
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    downloadVideo(url, fallbackName = 'video.mp4') {
      if (!url) return;
      const fileName = this.extractFileName(url) || fallbackName;
      window.open(url, '_blank', 'noopener,noreferrer');
      this.triggerVideoDownload(url, fileName);
    },
    async triggerVideoDownload(url, fileName = 'video.mp4') {
      if (!url || typeof document === 'undefined') return;
      try {
        const response = await fetch(url, { mode: 'cors' });
        if (!response.ok) throw new Error('Failed to fetch video');
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    extractFileName(url) {
      if (!url) return '';
      try {
        return url.split('/').pop().split('?')[0] || 'video.mp4';
      } catch (error) {
        return 'video.mp4';
      }
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false; // reset back after 2 sec
        }, 2000);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/views/components/summeryPageNew/summeryPageNew.component.js